/**
 * Management accounting reports
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The AccountsReceivable model module.
* @module model/AccountsReceivable
* @version 1.0.0
*/
export default class AccountsReceivable {
    /**
    * Constructs a new <code>AccountsReceivable</code>.
    * Дебиторская задолженность на конец периода
    * @alias module:model/AccountsReceivable
    * @class
    * @param _date {Date} 
    * @param current {Number} 
    * @param overdue {Number} 
    * @param cashForecast {Number} 
    * @param total {Number} 
    */

    constructor(_date, current, overdue, cashForecast, total) {
        

        
        

        this['date'] = _date;this['current'] = current;this['overdue'] = overdue;this['cashForecast'] = cashForecast;this['total'] = total;

        
    }

    /**
    * Constructs a <code>AccountsReceivable</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/AccountsReceivable} obj Optional instance to populate.
    * @return {module:model/AccountsReceivable} The populated <code>AccountsReceivable</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountsReceivable();

            
            
            

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Date');
            }
            if (data.hasOwnProperty('current')) {
                obj['current'] = ApiClient.convertToType(data['current'], 'Number');
            }
            if (data.hasOwnProperty('overdue')) {
                obj['overdue'] = ApiClient.convertToType(data['overdue'], 'Number');
            }
            if (data.hasOwnProperty('cashForecast')) {
                obj['cashForecast'] = ApiClient.convertToType(data['cashForecast'], 'Number');
            }
            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Date} date
    */
    date = undefined;
    /**
    * @member {Number} current
    */
    current = undefined;
    /**
    * @member {Number} overdue
    */
    overdue = undefined;
    /**
    * @member {Number} cashForecast
    */
    cashForecast = undefined;
    /**
    * @member {Number} total
    */
    total = undefined;








}


